export default "__VITE_ASSET__DSa5EAtA__"